import React, {useState} from "react";
import axios from 'axios';
import { Action, Store } from "@byhuz/huz-ui-state";
import ModalBox from "components/Alert/Modal.js";
import Spinner from "components/Alert/Spinner";
import useAuth from "components/Common/UseAuth";
import Paypal from "components/Common/Paypal";

// components
export default function MapCodes() {
    const {checkSession,user}=useAuth();
    const [loading, setLoading] = useState(false);
    const [modalDetail, setModalDetail] = useState("");  
    const showModal = (title,desc) => {
      setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
          setModalDetail(<div></div>);          
      }}/>);
    }

    const [headUnitType, setHeadUnitType] = React.useState([
      {"id":"NTG35","caption":"Comand NTG3.5", sku:"ntg35map"},
      {"id":"NTG45","caption":"Comand NTG4.5", sku:"ntg45map"},
      {"id":"NTG50","caption":"Comand NTG5.0", sku:"ntg50map"},
      {"id":"NTG51","caption":"Comand NTG5.1", sku:"ntg51map"},
      {"id":"NTG55","caption":"Comand NTG5.5", sku:"ntg55map"},
      {"id":"NTG60","caption":"Comand NTG6.0", sku:"ntg60map"},
      {"id":"ASTONNTG50","caption":"ASTON Martin NTG5.0", sku:"astonntg50map"}
    ]);
    const [defaultHeadUnitType, setDefaultHeadUnitType] = React.useState(null);    
    const [ swid, setSwid ] = React.useState("");
    const [ mapCodes, setMapCodes] = React.useState(null);
    const [ vin, setVin ] = React.useState("");
    const [ pincode, setPincode ] = React.useState("");
    const [ sku, setSku] = React.useState(null);
    const [ showGenButton, setShowGenButton] = React.useState(false);

    const countRef = React.useRef(0);
    const intervalIDRef = React.useRef(null);    

  // Login Function
  const handleSubmitNTG = (e) => {
    e.preventDefault();

    if (vin==="" || swid==="" || vin.length!==17) {
        showModal("Map Code",
            <>     
            <span>Check Map Version or VIN Number</span>   
            </>  
        );
        return;
    }

    setLoading(true);
    intervalIDRef.current = setInterval(getCodeFromServer,3000);
    getCodeFromServer();
  }
  
  const getCodeFromServer = () => {
    const ntgData = {
      vin: vin.toLocaleUpperCase(),
      hu: defaultHeadUnitType,
      id: swid,
      sku: sku
    }

    axios.post('generatemapcode',ntgData)
    .then(res=>{

      if (parseInt(res.data.code)===404) {       
            showModal("Map Code",
                <>     
                <span>Map Code Not Generated!</span>   
                </>  
            );
            setLoading(false);
            clearInterval(intervalIDRef.current);
            intervalIDRef.current = null;
            return;
      }

      if (parseInt(res.data.code)===400) {       
          showModal("Map Code",
              <>     
              <span>Not Enough Credit, Please buy credits!</span>   
              </>  
          );
          setLoading(false);
          clearInterval(intervalIDRef.current);
          intervalIDRef.current = null;
          return;
      }

      /*
      if (parseInt(res.data.code)===200 || parseInt(res.data.code)===201) {      
        //console.log(res.data.payload);        
        setPincode(res.data.payload.result.mapcode);
        checkSession();
      }
      */

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===1) {                     
        setPincode("Not Generated!");
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
        showModal("Map Code",
            <>     
            <span>Try Again!</span>   
            </>  
        );
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3) {                     
        setPincode(res.data.payload.result.mapcode);
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
      }

      if (parseInt(res.data.code)===300 || parseInt(res.data.code)===301) {      
        setPincode("Processing, please wait...")
      }

    })
    .catch(err=>{
      console.log(err);
      Store.dispatch(Action.update("loggedIn", false));
      Store.dispatch(Action.update("user"));
      return;
    }); 
    
    if (countRef.current>=10) {
      countRef.current = 0;
      setLoading(false);
      clearInterval(intervalIDRef.current);
      intervalIDRef.current = null;
      showModal("Map Code",
        <>     
        <span>Map Code Not Generated!, Try Again</span>   
        </>  
      );      
    }
        
    countRef.current++;     
  }

  const PaymentSuccess = () => {    
    setLoading(false);
    checkSession();
    showModal("MBLink Payment Method",
        <>     
          <span>Thank you for purchasing...</span>   
        </>  
    );
  }

  const PaymentError = (err) => {
    setLoading(false);
    showModal("MBLink Payment Method",
        <>     
          <span>Payment could not be received. Please try again!</span>   
        </>  
    );
  }

  const PaymentStart = () => {
    setLoading(true);
  }  

  const doPayment = (price,sku) => {
    showModal("MBLink Payment Method",
        <>     
          <Paypal sku={sku} onSuccess={PaymentSuccess} onError={PaymentError} onStartTransaction={PaymentStart}></Paypal>   
        </>  
    );
  }

  const getPrice = (sku) => {
    let price = 0;
    user.availabletokens.forEach(skutypes => {
        if (skutypes.sku===sku) {  
          price=skutypes.price;
          return;          
        }
    });
    return price;
  }

  const getMaps = (headUnitType) => {

    axios.post('mapcodes',{'hu':headUnitType})
    .then(res=>{
      if (parseInt(res.data.code)===400) {          
        Store.dispatch(Action.update("loggedIn", false));
        Store.dispatch(Action.update("user"));
        return;
      }

      if (parseInt(res.data.code)===404) {            
          Store.dispatch(Action.update("loggedIn", false));
          Store.dispatch(Action.update("user"));
          return;
      }

      if (parseInt(res.data.code)===200) {      
        console.log(res.data.payload);        
        setMapCodes(res.data.payload.result);
        setSwid(getMapId(getUserRegion(),res.data.payload.result));
      }
    })
    .catch(err=>{
      console.log(err);
      Store.dispatch(Action.update("loggedIn", false));
      Store.dispatch(Action.update("user"));
      return;
    });  
  }     

  const regionsToCountriesTable = [
    { region: "EUROPE", countries: ["AL", "AD", "BE", "BA", "BG", "DK", "DE", "EE", "FI", "FR", "GR", "IE", "IS", "IT", "XK", "HR", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK", "NO", "AT", "PL", "PT", "RO", "RU", "SM", "SE", "CH", "RS", "SK", "SI", "ES", "CZ", "UA", "UK", "HU", "VA", "GB", "BY", "CY"] },
    { region: "N.AMERICA", countries: ["US", "CA", "MX"] },
    { region: "S.AMERICA", countries: ["BR", "AR", "CO"] },
    { region: "AFRICA/MIDDLE EAST", countries: ["ZA", "NG", "EG", "DZ", "MA", "KE", "ET", "SD", "TN", "UG", "GH", "MA", "CI", "MZ", "SN", "AO", "MG", "CM", "CF", "NE", "ML", "ZM", "MW", "TD", "BI", "RW", "SO", "GN", "TG", "MR", "BW", "GM", "SZ", "RE", "DJ", "LS", "ER", "SC", "ST", "KM", "YT", "SH", "EH", "CF", "GA", "BJ", "BV", "CV", "KM", "KM", "CD", "CG", "CF", "CV", "KM", "DJ", "GQ", "GA", "GW", "LR", "LY", "MG", "ML", "MR", "MU", "YT", "NE", "RW", "SH", "SN", "SC", "SL", "SO", "SD", "SZ", "TG", "TN", "UG", "CD", "TZ", "ZM", "ZW", "BJ", "BW", "BF", "BI", "CM", "CF", "TD", "KM", "CV", "GQ", "ER", "GM", "GH", "GN", "GW", "LR", "LS", "MG", "MW", "ML", "MR", "MU", "YT", "MZ", "NA", "NE", "NG", "RE", "RW", "SH", "SH", "SN", "SC", "SL", "SO", "ZA", "SS", "ST", "SZ", "TD", "TG", "TZ", "UG", "YT", "ZA", "ZM", "ZW", "SO", "ZA", "SS"] },
    { region: "CHINA", countries: ["CN"] },
    { region: "AUSTRALIA", countries: ["AU", "NZ"] },
    { region: "JAPAN", countries: ["JP"] },
    { region: "KOREA", countries: ["KR"] },
    { region: "INDIA", countries: ["IN"] },
    { region: "TAIWAN", countries: ["TW"] },
    { region: "TURKEY", countries: ["TR"] },
    { region: "SOUTH EAST ASIA", countries: ["BN", "KH", "TL", "ID", "LA", "MY", "MM", "PH", "SG", "TH", "VN"] }
  ];

  const getUserRegion = () => {
      var acceptLanguages = navigator.languages;

      for (const language of acceptLanguages) {
          for (const item of regionsToCountriesTable) {
              if (item.countries.includes(language.toUpperCase())) {
                  return item.region;
              }
          }
      }
      return 'UNKNOWN';
  }

  const getMapId = (region,mapTable) => {
    for (const item of mapTable) {
        if (item.caption.includes(region)) {
            return item.id;
        }
    }
  }

  React.useEffect(()=>{     


},[]);

  return (
    <>
    {loading?<Spinner show={loading} />:null}
    {modalDetail!==""?modalDetail:null}
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">

            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-gray-800 text-xl font-bold">COMAND NTG MAP CODES</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                    <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
                    </h6>
                    <div className="flex flex-wrap">                        

                        {/* Map Gen */}
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    HEAD UNIT TYPE
                                </label>
                                <div className="mb-3 pt-0">
                                    <select 
                                    onChange={e=> {
                                        if (e.target.value!=="") {
                                          setDefaultHeadUnitType(e.target.value);
                                          getMaps(e.target.value);
                                          setSku(headUnitType.filter(item=>item.id===e.target.value)[0].sku);
                                          setShowGenButton(true);
                                          setSwid("");
                                        } else {
                                          setDefaultHeadUnitType(null);
                                          setMapCodes(null);
                                          setSku(null);
                                          setShowGenButton(false);
                                        }
                                      }   
                                    }                                                           
                                    className="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">                                        
                                    <option value="">Choose Type</option>
                                    {headUnitType!=null && headUnitType.map((item,index) => {
                                        return (
                                        <option key={index} value={item.id}>{item.caption}</option>
                                        );
                                    })}                             
                                    </select>
                                </div>
                            </div>
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Comand {defaultHeadUnitType} Version
                                </label>
                                <div className="mb-3 pt-0">
                                    <select  
                                    value={swid}                                   
                                    onChange={e=> setSwid(e.target.value)}                                                                                                       
                                    className="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">                                        
                                    <option value="">Choose Version</option>                                    
                                    {mapCodes!=null && mapCodes.map((item,index) => {
                                        return (
                                        <option key={index} value={item.id}>{item.caption}</option>
                                        );
                                    })}                             
                                    </select>
                                    <label
                                    className="block uppercase text-green-500 text-xs mb-2 text-right">Suggested Region: {getUserRegion()}</label>                                    
                                </div>
                                

                            </div>                            
                            <div className="relative w-full mb-3">

                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    VIN Number (17 chars)
                                </label>
                                <div className="mb-3 pt-0">
                                    <input type="text" 
                                        placeholder="WDD2XX0000A123456" 
                                        onChange={e=> setVin(e.target.value.toLocaleUpperCase())}                                        
                                        className="uppercase px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-1/3"/>
                                </div>

                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Your Map Code
                                </label>
                                <div className="mb-3 pt-0">
                                    <input type="text" disabled defaultValue={pincode} className="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-1/3"/>
                                </div>

                            </div>
                            {showGenButton ? 
                            <div className="relative w-full mb-3">
                                <button
                                className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button" onClick={handleSubmitNTG}
                                >
                                Generate Code {defaultHeadUnitType}
                                </button>
                                <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                                  type="button"
                                  onClick={(e)=>doPayment(getPrice(sku),sku)}
                                  >
                                    BUY {getPrice(sku)} EUR 
                                </button>
                            </div> 
                            : null}                           
                        </div>  
                        {/* Map Gen */}

                    </div>

                    <hr className="mt-6 border-b-1 border-gray-400" />

                </form>
                </div>
            </div>

        </div>
      </div>
    </>
  );
}
